export const AGREEMENT = {
  SALARY_TYPE: {
    CONTRACT_SALARY: 1,
    HOURS_SALARY: 2,
    DIFFERENT_HOURS_SALARIES: 3,
  },
  AGREEMENT_TYPE: {
    UMOWA_ZLECENIE: 1,
    UMOWA_O_DZIELO: 2,
    UMOWA_O_PRACE: 3,
    UMOWA_NA_OKRES_PROBNY: 4,
    UMOWA_NA_ZASTEPSTWO: 5,
    UMOWA_POWOLANIE: 6,
  },
  AGREEMENT_TYPE_PREFIX: {
    UMOWA_ZLECENIE: 'UZ',
    UMOWA_O_DZIELO: 'UoD',
    UMOWA_O_PRACE: 'UoP',
    UMOWA_NA_OKRES_PROBNY: 'UnOP',
    UMOWA_NA_ZASTEPSTWO: 'UnZ',
    UMOWA_POWOLANIE: 'Powołanie',
  },
  PAYMENT_DEADLINE_TYPE_OPTIONS: {
    IN_ARREARS: 1,
    IN_ADVANCE: 2,
    IN_ARREARS_END_OF_MONTH: 3,
    BASED_ON_BILL_ISSUE_DATE: 4,
  },
};
